import React, { useEffect } from "react";
import { Typography } from "@mui/material";

const TerminosCondiciones = () => {
  useEffect(() => {
    window.scrollTo(0, -0);
  }, []);

  return (
    <main>
      <Typography gutterBottom color="textPrimary" variant="h3" mt={10} mb={5}>
        WWU Terminos y condiciones
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        1. RELACIÓN CONTRACTUAL
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Los presentes términos y condiciones de uso (en adelante denominados
        como los “Términos y Condiciones”) regulan el acceso o uso que usted
        haga, como persona, dentro y/o fuera de la República Mexicana, de
        aplicaciones móviles, páginas web, plataformas tecnológicas (en
        adelante denominados como la “Plataforma Wwu”) puestos a su
        disposición por la empresa denominada WWUnit, esta última como una
        sociedad constituida bajo las leyes mercantiles de la República
        Mexicana, con domicilio social ubicado en Dirección Ciudad de México,
        debidamente inscrita ante el Registro Público de la Propiedad y de
        Comercio de la Ciudad de México, bajo el folio mercantil N-XXXXXXX.
        (en lo sucesivo “Wwu”).
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        CONSENTIMIENTO SOBRE EL USO DE LA “PLATAFORMA WWU”
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Al acceder y hacer uso de la “Plataforma Wwu”, usted consiente y
        acuerda vincularse jurídicamente por estos “Términos y Condiciones”,
        estableciendo una relación contractual con “Wwu”. Si usted no acepta
        estos “Términos y Condiciones”, no podrá acceder o hacer uso de la
        “Plataforma Wwu”. Estos “Términos y Condiciones” sustituyen
        expresamente todo acuerdo o compromiso celebrado previamente con
        usted. “Wwu” podrá variar o modificar los “Términos y Condiciones”, en
        cualquier momento y sin necesidad de previo aviso. “Wwu” podrá dejar
        de ofrecer o restringir el acceso a la “Plataforma Wwu” o a cualquier
        parte de ella, en cualquier momento y por cualquier motivo, sin previo
        aviso. En la “Plataforma Wwu” se podrán aplicar condiciones
        complementarias o especiales a determinados productos y/o servicios,
        tales como políticas por temporadas, eventos, actividades,
        promociones, descuentos, así como otros de carácter análogo, y dichas
        condiciones complementarias o especiales se le comunicarán a usted en
        relación con los productos y/o servicios aplicables. Las condiciones
        complementarias o especiales prevalecerán sobre los “Términos y
        Condiciones” generales señalados en este instrumento. “Wwu” podrá
        modificar los “Términos y Condiciones” de los productos y/o servicios
        cuando así lo considere necesario. Toda reforma o modificación a los
        “Términos y Condiciones” entrará en vigor con posterioridad a la
        publicación de dicha reforma por parte de “Wwu”, o bien, cuando se
        hayan actualizado en este instrumento. El acceso o uso continuado de
        la “Plataforma Wwu”, constituye el consentimiento para vincularse a
        los “Términos y Condiciones” y sus respectivas modificaciones o
        reformas. La recopilación y el tratamiento que hace “Wwu” de la
        información personal en relación con el uso de la “Plataforma Wwu”, es
        de conformidad con lo dispuesto por la política de privacidad de
        “Wwu”, visible en www.wwu.mx, así como en el capítulo correspondiente
        al presente instrumento.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        2. NATURALEZA JURÍDICA
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Los presentes “Términos y Condiciones” de uso regulan la relación
        contractual de carácter comercial entre los Consumidores o Usuarios
        que acceden y/o usan la “Plataforma Wwu” y “Wwu”, especialmente en la
        autorización de uso que se otorgan ambas partes respectivamente sobre
        el uso que se da a la “Plataforma Wwu”.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        3. GLOSARIO DE TÉRMINOS
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Comercio Electrónico: Comprende el envío, transmisión, recepción y
        almacenamiento de mensajes de datos por vía electrónica. Las dudas que
        surjan respecto de la eficacia y validez de los mensajes de datos y
        demás actividades vinculadas al comercio electrónico, se interpretarán
        de conformidad con el Código de Comercio, Código Civil Federal, o en
        su caso, por la Ley Federal de Protección al Consumidor. Socio Wwu:
        Persona física o jurídica que de manera habitual y directa,
        comercializa productos o servicios, y que para este efecto se
        encuentra vinculado a la “Plataforma Wwu” para la venta directa de
        productos y/o servicios al público en general. Consumidor o Usuario: A
        quien accede y/o usa la “Plataforma Wwu” como mecanismo de
        referenciación de productos y/o servicios, a fin de poder adquirir los
        mismos de la gama de productos y/o servicios que ofrece el Socio Wwu.
        Compraventa: Es el acuerdo de voluntades celebrado por medios
        electrónicos entre el Socio Wwu y los Consumidores o Usuarios, en
        donde el Socio Wwu realiza una oferta de productos y/o servicios, y el
        Consumidor o Usuario realiza la compra de cualquiera de ellos,
        obligándose este último al pago de un precio cierto y en dinero a
        favor del Socio Wwu, quien a su vez se obliga a entregar o a prestar
        el producto y/o servicio convenido en el lugar donde se defina el
        objeto de compraventa. Datos Personales: Toda información que permite
        identificar o hacer identificable a una persona física. Interacción en
        la Plataforma: A la posibilidad que tienen los Consumidores o Usuarios
        para conocer los productos y/o servicios exhibidos en la “Plataforma
        Wwu”, así como la publicidad puesta a disposición a través de la
        propia plataforma. Mensajes de Datos: La información generada,
        enviada, recibida, almacenada o comunicada por medios electrónicos,
        ópticos o similares. Wwu: A la empresa denominada WWUnit, esta última
        como una sociedad constituida bajo las leyes mercantiles de la
        República Mexicana, con domicilio social ubicado en Calle Rafael
        Alducín #30, Colonia del Valle, Delegación Benito Juárez, Código
        Postal 03100, Ciudad de México, debidamente inscrita ante el Registro
        Público de la Propiedad y de Comercio de la Ciudad de México.
        Asimismo, como el encargado de administrar operativa y funcionalmente
        la “Plataforma Wwu”, representado para los efectos de los presentes
        “Términos y Condiciones”, por la persona física o jurídica que ésta
        designe. Sistema de Pagos: Servicio que permite la transacción de
        pagos mediante la plataforma de Stripe, Paypal, android pay, apple
        pay entre Consumidores o Usuarios y Socios Wwu; lo anterior a través
        de los medios electrónicos o plataformas tecnológicas que tenga
        implementado “Wwu”. Cookies: Cadenas de texto enviadas virtualmente
        que son almacenadas por el uso de la “Plataforma Wwu”, para la
        consulta de las actividades y preferencias de los usuarios.
        Publicidad: Toda forma de comunicación realizada por “Wwu”, con el fin
        de brindar información sobre productos, servicios, actividades
        comerciales y/o comunicar estrategias o campañas publicitarias o de
        mercadeo, propias o de terceros, realizada como mecanismo de
        referencia y no como oferta pública de venta. Productos o Servicios:
        Exclusivamente aquellos bienes y/o servicios de consumo general
        exhibidos a través de la “Plataforma Wwu”. Ventanas Emergentes
        (Pop-Ups): Ventana o aviso de internet que emerge automáticamente en
        cualquier momento cuando se utiliza la “Plataforma Wwu”, especialmente
        utilizado para la formalización de la compraventa celebrada por medios
        electrónicos entre Consumidores o Usuarios y Socios Wwu.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        4. TÉRMINOS Y CONDICIONES
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Los presentes “Términos y Condiciones” regulan la autorización de uso
        que otorga “Wwu” a los Consumidores o Usuarios, para que éstos
        ingresen a la “Plataforma Wwu” se informen sobre los servicios o
        productos de consumo general exhibidos por los Socios Wwu, a fin de
        que puedan llevar a cabo la reserva y/o compra de dichos productos y/o
        servicios a través de la “Plataforma Wwu”, de forma directa a los
        Socios Wwu por medio de los medios tecnológicos o plataformas que
        tenga implementado “Wwu”. “Wwu”, a través de la “Plataforma Wwu”
        realiza, de manera enunciativa, las siguientes acciones: a) exhibe
        diferentes servicios y/o productos de consumo general, de forma
        publicitaria para que puedan servir de referencia a los Consumidores o
        Usuarios y/o al público en general; b) facilita el encuentro comercial
        entre Consumidores o Usuarios y Socios Wwu, permitiendo que se lleve a
        cabo la formalización del vínculo comercial entre estos; c) permite el
        uso del sistema de pagos Stripe, para la compra o adquisición de
        productos y/o servicios, sin que este proceso implique un vínculo
        entre “Wwu” y los Consumidores o Usuarios, ya que el pago se lleva a
        cabo de forma directa al Socio Wwu, a través del sistema de pagos de
        Stripe, Paypal, android pay, apple pay.; d) sirve de medio de envío
        de comunicaciones o publicidad masiva para Consumidores o Usuarios, o
        bien, como medio de comunicación entre Consumidores o Usuarios y
        Socios Wwu. La relación contractual entre Consumidores o Usuarios y
        Socios Wwu, se da con Consumidores o Usuarios que se encuentren en el
        territorio de la República Mexicana, o que estando en el extranjero,
        reservan y/o adquieren productos y/o servicios para ser entregados o
        prestados en el Territorio de la República Mexicana, pagando una
        contraprestación económica a través del sistema de pagos Stripe,
        previo a la entrega o prestación de los productos o servicios. A
        través de la “Plataforma Wwu” se exhiben productos y/o servicios que
        los Socios Wwu comercializan para su consumo final, lo cual es
        conocido y aceptado por los Consumidores o Usuarios, quienes buscan
        satisfacer una necesidad personal o de terceros, y en ningún momento
        para su comercialización, reventa o cualquier otro tipo de transacción
        comercial.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        5. MODIFICACIÓN
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        “Wwu” podrá modificar libremente y en cualquier momento, los presentes
        “Términos y Condiciones” de uso de la “Plataforma Wwu”, los que además
        serán actualizados y puestos a disposición de los Consumidores o
        Usuarios en la “Plataforma Wwu”, siendo la última versión publicada la
        que regirá la relación comercial de toda reserva y/o compra de
        productos y/o servicios, así como demás operaciones que permita la
        “Plataforma Wwu”. Asimismo, “Wwu” cuenta con plena autonomía para
        modificar el uso que deba darse a la “Plataforma Wwu” por parte de los
        Consumidores o Usuarios, con el único deber de informarlo por un medio
        virtual que permita su publicación y comunicación al público en
        general.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        6. PLATAFORMA WWU
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        La “Plataforma Wwu” es el conjunto de aplicaciones móviles, páginas
        web y plataformas tecnológicas, de uso gratuito para el Consumidor o
        Usuario, y por diversos medios, así como susceptible de ser descargada
        en dispositivos móviles por medio de tiendas virtuales de aplicaciones
        como Apple y Google (en adelante denominados como “App Store” y
        “Google Play”, respectivamente). La “Plataforma Wwu” permite a los
        Consumidores o Usuarios reservar y adquirir productos y/o servicios de
        consumo general. El Consumidor o Usuario reconoce y acepta usar la
        “Plataforma Wwu” sólo como un medio de encuentro con los productos y/o
        servicios que ofrecen los Socios Wwu, permitiendo que los Consumidores
        o Usuarios lleven a cabo la adquisición o compra de Productos y/o
        Servicios para su consumo final y/o para la satisfacción de sus
        necesidades personales o de terceros, de conformidad con la
        normatividad mercantil aplicable en la República Mexicana. El uso de
        la “Plataforma Wwu” lo realiza el Consumidor o Usuario como persona
        capaz y mayor de edad, manifestando que para la celebración de la
        compraventa de Productos y/o Servicios, cuenta con plena capacidad
        legal para ser sujeto de derechos y obligaciones, y obligarse en los
        términos del presente instrumento. El Consumidor o Usuario reconoce
        expresamente mediante la aceptación de los presentes “Términos y
        Condiciones” que “Wwu” no será responsable en ningún momento y bajo
        ninguna circunstancia, del incumplimiento en que pudiera incurrir el
        Socio Wwu, sobre cualquier producto y/o servicio que los Consumidores
        o Usuarios adquieran a través de la “Plataforma Wwu”. Los Socios Wwu,
        teniendo plena capacidad de contratación, acceden a la “Plataforma
        Wwu” y comercializan sus productos y/o servicios con los Consumidores
        o Usuarios, reservándose el derecho de aceptar o rechazar la
        comercialización de los mismos antes de que se actualice realice la
        compraventa. La formalización de la compraventa celebrada por medios
        electrónicos se da en el momento en que el Socio Wwu acepta la
        solicitud del Consumidor o Usuario, respecto a los productos y/o
        servicios que se ofrecen en la “Plataforma Wwu”; dicha aceptación
        procederá, en su caso, al momento en que el Consumidor o Usuario
        recibe la confirmación del producto y/o servicio. Por lo tanto, el
        Socio Wwu podrá aceptar total o parcialmente la solicitud de compra de
        los productos y/o servicios, evento en el cual informará en el resumen
        de compra, sobre qué productos o servicios se actualiza la
        compraventa.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        7. LICENCIA
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        La aceptación y consentimiento del Consumidor o Usuario a los
        presentes “Términos y Condiciones”, harán que “Wwu” otorgue a los
        Consumidores o Usuarios, una licencia limitada no exclusiva,
        revocable, intransferible y no sub-licenciable para que el Consumidor
        o Usuario tenga: a) acceso y uso de la “Plataforma Wwu” en el
        dispositivo personal del Consumidor o Usuario, y sólo en relación con
        el uso para los fines aquí expuestos; y b) acceso y uso de cualquier
        contenido, información y material relacionado que pueda ponerse a su
        disposición, para su uso personal y no comercial. “Wwu” y sus
        licenciantes se reservan cualquier derecho que no haya sido
        expresamente otorgado en los presentes “Términos y Condiciones”.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        8. CUENTA DEL CONSUMIDOR O USUARIO:
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Los Consumidores o Usuarios usan la “Plataforma Wwu” como referencia
        para la compra de productos y/o servicios que se encuentran exhibidos
        en la “Plataforma Wwu”, teniendo como condición indispensable la
        creación de una cuenta de usuario (en adelante la “Cuenta de
        Usuario”), donde se solicitarán datos como nombre, fecha de
        nacimiento, teléfono, domicilio, correo electrónico y medios de pago;
        esta información se utiliza para a) la plena identificación de los
        Consumidores o Usuarios que pretenden adquirir los productos y/o
        servicios de los Socios Wwu; b) para el cumplimiento de la relación
        comercial; c) para la prevención de fraudes; y d) para vincular al
        Consumidor o Usuario con el Socio Wwu. La información proporcionada
        deberá ser veraz, exacta y actualizada. Para obtener una cuenta de
        usuario, deberá acreditarse que usted tiene la mayoría de edad. En
        caso de que usted sea menor de 18 años, podrá usar el servicio
        únicamente a través de un padre o tutor. En caso de que los
        Consumidores o Usuarios tengan cuentas en redes sociales como Facebook
        y Google, podrán crear su “Cuenta de Usuario” con la utilización de
        las credenciales definidas en dichas redes, para lo cual la
        “Plataforma Wwu” comunicará esta opción al Consumidor o Usuario. Una
        vez suministrada la información necesaria para el uso de la
        “Plataforma Wwu”, se validará por parte de “Wwu” el nombre de usuario
        y contraseña para acceder y/o usar la “Plataforma Wwu”. Los
        Consumidores o Usuarios podrán, además de proporcionar la información
        obligatoria y facultativa requerida al momento de la creación de la
        “Cuenta de Usuario”, suministrar voluntariamente más datos
        relacionados con su individualización al momento en que lleve a cabo
        la creación de su propio perfil dentro de la “Plataforma Wwu”. El uso
        de la “Cuenta de Usuario” es personal e intransferible. Los
        Consumidores o Usuarios no se encuentran facultados para ceder a
        terceros los datos de validación que dan acceso a la “Plataforma Wwu”.
        En caso de olvido de los datos de validación o de usurpación de éstos,
        será facultad del Consumidor o Usuario, informar a “Wwu” sobre dicha
        circunstancia a través de la opción denominada “Recuperar Contraseña”,
        o a través de una comunicación enviada al correo electrónico:
        contacto@wwu.mx Las “Cuentas de Usuarios” serán administradas por
        “Wwu”, a su discreción o por la persona que éste designe, teniendo
        plena facultad para la conservación o no de la cuenta, cuando la
        información suministrada por los Consumidores o Usuarios no sea veraz,
        completa o segura, o cuando se presente incumplimiento de las
        obligaciones de los Consumidores o Usuarios a la relación comercial
        con cualquiera de los Socios Wwu. En ningún momento “Wwu” solicitará
        al Consumidor o Usuario información que no resulte necesaria para su
        vinculación comercial con el Socio Wwu y/o para facilitar el pago que
        este último deba realizar por los productos y/o servicios, por lo que
        los datos de tarjetas débito o crédito, solo serán solicitados al
        momento de realizar el pago virtual a través de la “Plataforma Wwu”.
        Éstos datos no serán almacenados por “Wwu”, pues únicamente serán
        inscritos directamente en el sistema de pagos Stripe, y se utilizarán
        directamente por el Consumidor o Usuario en la “Plataforma Wwu”, donde
        se informará sobre las condiciones de seguridad y privacidad en que se
        efectúa el mismo. Con la creación de la “Cuenta de Usuario”, los
        Consumidores o Usuarios manifiestan su entera voluntad y aceptación
        expresa e inequívoca sobre los presentes “Términos y Condiciones” de
        uso de la “Plataforma Wwu”. Al momento de la aceptación de los
        presentes “Términos y Condiciones”, el Consumidor o Usuario autoriza
        el uso de Cookies por parte de “Wwu” en toda actividad de uso que
        realice en la “Plataforma Wwu”. El usuario será el único responsable
        respecto del uso de la cuenta de usuario, por lo que éste se
        compromete a conservar la seguridad y secrecía del nombre de usuario y
        contraseña, así como de los dispositivos mediante los cuales acceda a
        la plataforma Wwu. Asimismo, el usuario deberá cerciorarse de tomar
        todas las medidas necesarias para salvaguardar la confidencialidad de
        su contraseña. Wwu se reserva del derecho de cancelar cuentas de
        usuario en caso de violaciones a los términos y Condiciones o
        cualquier otra política implementada por Wwu, así como por cualquier
        otra conducta ilícita o que pueda dañar la reputación de Wwu.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        9. CAPACIDAD JURÍDICA
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        EL Consumidor o Usuario manifiesta que la relación contractual que se
        puede llegar a generar por el uso de la “Plataforma Wwu”, será directa
        y exclusivamente con los Socios Wwu, y que consistirá en una
        compraventa de productos y/o servicios por comercio electrónico, en la
        que el Consumidor o Usuario será el comprador, y el Socio Wwu será el
        vendedor de los productos y/o servicios. En virtud de las condiciones
        de capacidad legal establecidas en la legislación mexicana vigente y
        de la validez de la manifestación de voluntad a través de medios
        electrónicos establecida en el Código Civil Federal y Código de
        Comercio, los Consumidores o Usuarios, al momento de la creación de la
        “Cuenta de Usuario”, manifiestan expresamente tener capacidad legal
        suficiente para celebrar el tipo de transacciones de Compraventa que
        se pueden o podrían llegar a realizar accediendo y/o usando la
        “Plataforma Wwu”.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        10. DESCRIPCIÓN DEL SERVICIO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        “Wwu” exhibe a través de su plataforma, los productos y/o servicios de
        consumo que están a disposición de los Consumidores o Usuarios para su
        conocimiento general. Esta comunicación de productos y/o servicios
        funge como referencia para los Consumidores o Usuarios, a fin de que
        puedan llevar a cabo su adquisición a través del sistema de pagos
        Stripe, este último como medio para realizar la compraventa celebrada
        por medios electrónicos. Para el proceso de compra, los Consumidores o
        Usuarios deberán estar plenamente identificados en su “Cuenta de
        Usuario” y seguir el procedimiento siguiente: a) Ingresar a la
        “Plataforma Wwu” y seleccionar el domicilio o ubicación para
        determinar los Socios Wwu que se encuentren disponibles dentro de su
        área de geolocalización. b) Seleccionar los productos y/o servicios de
        su preferencia. Al seleccionar los productos y/o servicios de su
        preferencia, se pone a disposición del Consumidor o Usuario las
        características generales y el valor o precio total de los mismos,
        permitiendo la plena individualización y análisis detallado para el
        discernimiento del Consumidor o Usuario, previo a la formalización de
        la compraventa. c) Seleccionar o definir la configuración general de
        los productos y/o servicios del Socio Wwu de que se trate. d)
        Seleccionar o definir la fecha, lugar u horario para la entrega y/o
        prestación de los productos y/o servicios; e) Validación o resumen de
        los productos y/o servicios. La “Plataforma Wwu” deberá exhibir al
        Consumidor o Usuario un resumen de los productos y/o servicios en
        cuanto a sus condiciones y características generales. Con ésta
        información el Consumidor o Usuario podrá validar los productos o
        servicios objeto de compraventa. Asimismo, se pone a disposición del
        Consumidor o Usuario el precio a pagar por el o los productos y/o
        servicios seleccionados, los cuales se encuentran reflejados
        unitariamente y/o en conjunto. El valor corresponderá al precio total
        de los productos y/o servicios que haya definido el Socio Wwu en el
        catálogo de productos y/o servicios, visibles en la “Plataforma Wwu”,
        incluyendo costos de transacción y/o impuestos que correspondan. Las
        circunstancias temporo-espaciales deberán encontrarse dentro del rango
        de cobertura de entrega y/o prestación de productos y/o servicios del
        Socio Wwu, ya que en caso contrario, no se permitirá la formalización
        de la compraventa. f) Forma de pago. El Consumidor o Usuario deberá
        seleccionar el medio de pago que desea utilizar, ya sea en efectivo o
        pago por medio de tarjeta bancaria del Consumidor o Usuario, y a
        través del sistema de pagos de Stripe. Al seleccionar el método de
        pago por medio de Stripe, el Consumidor o Usuario acepta los términos
        y condiciones de Stripe. g) Registro. Al momento de definir la forma
        de pago, el Consumidor o Usuario deberá ingresar los datos de la
        tarjeta bancaria con la que hará la compra de los productos y/o
        servicios seleccionados. h) Una vez completados los pasos anteriores,
        se le exhibirá al Consumidor o Usuario a través de una ventana
        emergente, un resumen detallado de la transacción y la información
        completa del Socio Wwu que ha aceptado la compra de los productos y/o
        servicios, y con el cual se celebra la compraventa; dicho resumen será
        enviado por correo electrónico al Consumidor o Usuario con la
        información de forma detallada. “Wwu” enviará vía correo electrónico,
        un recibo al Consumidor o Usuario con el detalle de la transacción. i)
        Entrega o prestación de los productos y/o servicios. Verificados todos
        los datos correspondientes a la transacción y al ámbito de cobertura
        de entrega o prestación de los productos y/o servicios, el Socio Wwu
        entregará o prestará en la dirección suministrada por el Consumidor o
        Usuario, a través de la “Plataforma Wwu”, los productos y/o servicios
        contratados. En caso de no poderse realizar la entrega o prestación de
        los productos y/o servicios por causas imputables al Consumidor o
        Usuario, el Socio Wwu dejará constancia de este hecho, y el Consumidor
        o Usuario podrá re-agendar la entrega o prestación de los productos
        y/o servicios, de forma directa con el Socio Wwu.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        11. OBLIGACIONES DEL CONSUMIDOR O USUARIO.
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Con la aceptación de los presentes “Términos y Condiciones de uso de
        la Plataforma Wwu”, el Consumidor o Usuario se obliga a: suministrar
        información veraz y fidedigna al momento de crear su propia “Cuenta de
        Usuario”; a abstenerse de transferir a terceros los datos de
        validación (nombre de usuario y contraseña); a abstenerse de acceder
        y/o usar la “Plataforma Wwu” para realizar actos contrarios a la
        moral, al orden público, a las buenas costumbres o actos o hechos
        ilícitos en contra de “Wwu”, de Socios Wwu o de terceros; a pagar
        oportunamente al Socio Wwu, la contraprestación económica definida en
        el proceso de compra; a cancelar los servicios que no desee, con por
        lo menos 12 horas de anticipación a la fecha y hora en que deban
        prestarse; a informar inmediatamente a “Wwu” en caso de olvido o
        usurpación de los datos de validación; a abstenerse de realizar
        conductas que atenten en contra del funcionamiento de la “Plataforma
        Wwu”; a abstenerse de requerir a los Socios Wwu, cualquier otro
        producto cuya comercialización, venta o distribución por teléfono,
        correo, internet o cualquier otro medio de comunicación, sea prohibida
        por la legislación vigente de la República Mexicana; a abstenerse de
        suplantar la identidad de otros Consumidores o Usuarios; a abstenerse
        de descifrar, descompilar o desensamblar, apropiarse de cualquier
        elemento de la “Plataforma Wwu” o de cualquiera de sus partes; a
        habilitar la utilización de ventanas emergentes durante la operación
        de la “Plataforma Wwu”; y en general, todas aquellas conductas
        necesarias para la ejecución del negocio jurídico materia de
        compraventa, como: 1) la recepción de los productos y/o servicios
        solicitados, 2) exhibir una identificación en caso de venta de
        productos de uso restringido, 3) verificar al momento de la validación
        que los productos y/o servicios seleccionados si corresponden a los
        requeridos, 4) informarse sobre las instrucciones de uso y/o consumo
        de los productos y/o servicios, y pagar el precio al Socio Wwu; 5)
        Sacar en paz y salvo a “Wwu” de cualquier reclamación de naturaleza
        jurídica en su contra por el uso de la “Plataforma Wwu”.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        12. OBLIGACIONES A CARGO DE WWU
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        En virtud de los presentes “Términos y Condiciones”, “Wwu” se obliga a
        suministrar información cierta, fidedigna, suficiente, clara y
        actualizada respecto de los productos y servicios de los Socios Wwu; a
        indicar las características generales de los productos y/o servicios
        para que sirvan de referencia a los Consumidores o Usuarios en el
        proceso de compraventa; a informar suficientemente a los Consumidores
        o Usuarios sobre los medios o métodos de pago, así como políticas de
        cancelación; a informar en el momento indicado los datos de los Socios
        Wwu con los cuales los Consumidores o Usuarios harán la compraventa; a
        enviar al correo electrónico suministrado por el Consumidor o Usuario,
        la constancia de la compraventa; a poner a disposición de los
        Consumidores o Usuarios los “Términos y Condiciones” de uso de la
        “Plataforma Wwu”; a utilizar la información únicamente para los fines
        establecidos en los presentes “Términos y Condiciones”; a utilizar
        mecanismos de información y validación durante la transacción como
        ventanas emergentes (Pop Ups), que permitan al Consumidor o Usuario
        aceptar o no cada paso del proceso de compraventa.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        13. DESCRIPCIÓN DE LOS PRODUCTOS O SERVICIOS
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Los productos y servicios exhibidos en la “Plataforma Wwu” serán de
        consumo general. Todos los productos y/o servicios cuentan con una
        descripción general; esta descripción se realiza en la “Plataforma
        Wwu” a partir de prácticas legales de visualización que en todo caso
        dependen del dispositivo en donde el Consumidor o Usuario los observe.
        La disponibilidad de productos y/o servicios, así como horarios,
        lugares y/o fechas será definida o determinada por el Socio Wwu a
        través de la “Plataforma Wwu”. Reconoce el Consumidor o Usuario que
        “Wwu” no es productor, proveedor, expendedor, agente, distribuidor y
        en general ningún tipo de comercializador de los productos que exhibe
        del Socio Wwu a través de la “Plataforma Wwu”, ya que “Wwu” únicamente
        opera o funge como una plataforma tecnológica que permite el encuentro
        comercial entre Consumidores o Usuarios y Socios Wwu, para la
        configuración o actualización de relaciones de consumo de productos
        y/o servicios. El Socio Wwu se reserva el derecho de actualizar,
        modificar y/o descontinuar en cualquier momento los productos y/o
        servicios exhibidos en la “Plataforma Wwu”.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        14. GARANTÍA Y PROPIEDAD INDUSTRIAL
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El Consumidor o Usuario acepta que la relación comercial se genera
        directamente con los Socios Wwu, por tanto, las reclamaciones por
        garantía se deberán realizar directamente ante los Socios Wwu, quienes
        tienen la obligación de cumplir con las reclamaciones en los términos
        de las leyes aplicables y vigentes de la República Mexicana. En su
        caso, “Wwu” sólo podrá llevar a cabo la ejecución de garantías o
        reclamaciones a través de la cancelación de cargos bancarios hechos a
        través del sistema de pagos Stripe, siempre que “Wwu” reciba la
        instrucción expresa por parte del Socio Wwu, y siempre que esto ocurra
        dentro del tiempo que permita la plataforma de pagos Stripe. En caso
        contrario, el Socio Wwu será el responsable de realizar los rembolsos
        por garantías o reclamaciones cuando se le haya enterado el monto de
        compraventa por medio del sistema de pagos Stripe. A través de la
        “Plataforma Wwu”, el Socio Wwu podrá poner a disposición de los
        Consumidores o Usuarios, la información de carácter comercial y
        publicitario, propia o de terceros, de conformidad a las buenas
        costumbres comerciales. En estos casos, “Wwu” no avala, garantiza o
        compromete su responsabilidad frente a los servicios y/o productos que
        se comercialicen por los Socios Wwu a través de la “Plataforma Wwu”,
        ya que esta sirve únicamente como medio de comunicación y/o
        vinculación entre Socios Wwu y los Consumidores o Usuarios. Toda la
        información puesta a disposición en la “Plataforma Wwu” como imágenes,
        publicidad, nombres, marcas, lemas y demás elementos de propiedad
        intelectual, son utilizados legítimamente por “Wwu”, ya sea porque son
        de su propiedad o porque tiene la autorización para ponerlos a
        disposición o porque se encuentra facultada por la legislación
        aplicable vigente. Mediante la utilización de la Plataforma Wwu, el
        usuario reconoce y acepta que Wwu, queda excluida de cualquier
        responsabilidad que pudiera ser causada por el uso no autorizado de
        las marcas u otros derechos de propiedad intelectual de terceros o
        contenidos en los sitios enlazados.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        15. OPERACIÓN DE LA PLATAFORMA
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        “Wwu” administra directamente o por medio de terceras personas la
        “Plataforma Wwu”. Toda la información que se comunica o publicita
        corresponde a información cierta y actualizada de los Socios Wwu. En
        ningún caso “Wwu” responderá por los daños directos o indirectos que
        sufra el Consumidor o Usuario por la utilización, incapacidad o
        negligencia en la utilización de la Plataforma Wwu”. La “Plataforma
        Wwu” se encuentra disponible las veinte y cuatro horas del día para su
        acceso y consulta para la realización de transacciones comerciales con
        Socios Wwu. La disponibilidad de la “Plataforma Wwu” es de 24 veinte y
        cuatro horas del día, pero la disponibilidad de los productos y/o
        servicios dependerá de la disponibilidad de que defina el Socios Wwu
        en la propia plataforma. “Wwu” realizará los mejores esfuerzos para
        mantener en operación la “Plataforma Wwu”, pero no garantiza la
        disponibilidad y/o estabilidad de la misma. “Wwu” se reserva el
        derecho de cancelar cualquier “Cuenta de Usuario” o de prohibir el
        acceso a la “Plataforma Wwu” a cualquier Consumidor o Usuario que
        realice conductas violatorias de los presentes “Términos y
        Condiciones” o que incumpla con las obligaciones contraídas en el
        presente instrumento.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        16. COMERCIO ELECTRÓNICO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        En cumplimiento de las disposiciones legales de la República Mexicana
        sobre mensajes de datos según el Código Civil Federal y Código de
        Comercio, se comunica que la legislación mexicana reconoce validez a
        los mensajes por medios electrónicos. En consecuencia, los
        Consumidores o Usuarios aceptan y reconocen que mediante el cruce de
        mensajes por medios electrónicos, el Consumidor o Usuario y los Socios
        Wwu, pueden dar lugar a la creación, transmisión, modificación y
        extinción de derechos y obligaciones. La transacción comercial que
        nace por este medio entre Consumidores o Usuarios y Socios Wwu, se
        refiere a la celebración de un contrato de compraventa de productos
        y/o servicios de consumo general por medios electrónicos, el cual se
        describe en la ventana emergente que acepta el Consumidor o Usuario al
        momento de la celebración del negocio jurídico. En ningún momento se
        configura alguna relación contractual diferente como suministro,
        distribución o demás similares.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        17. MANEJO DE INFORMACIÓN:
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El tratamiento de la información recopilada a través de la “Plataforma
        Wwu” en las transacciones realizadas, es proporcionada por los
        Consumidores o Usuarios de forma libre y voluntaria para que esta sea
        administrada por “Wwu”, los Socios Wwu o por quien éste último designe
        para el cumplimiento de los deberes adquiridos en este instrumento.
        Por otro lado, los datos recolectados serán objeto de análisis para
        fines de mejorar la estrategia de negocio del Socios Wwu, apoyada en
        herramientas de inteligencia de negocios y datos, que permitan
        adquirir conocimientos prospectivos para fines de predicción,
        clasificación y segmentación de productos y/o servicios. El Consumidor
        o Usuario podrá ejercer su derecho de acceso, rectificación,
        cancelación y oposición de sus Datos Personales existentes en las
        bases de datos asociadas a la “Plataforma Wwu”. Para ello, el
        Consumidor o Usuario deberá realizar la solicitud a la dirección
        electrónica: contacto@wwu.mx, detallando por escrito las
        modificaciones a realizar y aportando los documentos que soporten su
        solicitud. Al aceptar los presentes “Términos y Condiciones”, el
        Consumidor o Usuario manifiesta expresamente haber leído y aceptado el
        aviso de privacidad que “Wwu” pone a su disposición en la dirección
        electrónica: www.wwu.mx. En caso de que Consumidores o Usuarios de
        otros países utilicen la “Plataforma Wwu”, se sujetarán completamente
        a lo dispuesto en los presentes “Términos y Condiciones”. El
        Consumidor o Usuario manifiesta expresamente tener capacidad legal
        para usar la “Plataforma Wwu” y para celebrar los negocios jurídicos
        que se puedan generar con los Socios Wwu. Asimismo, manifiesta haber
        suministrado información real, veraz y fidedigna, por ende, de forma
        expresa e inequívoca declara que ha leído, que entiende y que acepta
        la totalidad de los supuestos previstos y regulados en los presentes
        Términos y Condiciones” de uso de la “Plataforma Wwu”, por lo que se
        compromete al cumplimiento total de las obligaciones aquí expresadas.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        18. LEGISLACIÓN Y JURISDICCIÓN
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Para todo lo que no se encuentre previsto en el presente instrumento,
        “Wwu”, los Consumidores o Usuarios y los Socios Wwu, acuerdan
        someterse a las leyes y jurisdicción concurrente de los Tribunales
        Civiles de la Ciudad de México. Para la interpretación, ejecución y
        cumplimiento de los presentes “Términos y Condiciones”, el Consumidor
        o Usuario acepta someterse a la jurisdicción concurrente de los
        Tribunales Civiles del Fuero Común de la Ciudad de México; renunciando
        expresamente al fuero que por ley o por razón de sus domicilios
        pudiera corresponderles, reconociendo que la controversia deberá ser
        por la vía mercantil y que sujetarse a las disposiciones legales del
        Código de Comercio y supletoriamente por el Código Civil Federal.
      </Typography>
    </main>
  );
};

export default TerminosCondiciones;
